import React from "react"

const GetRandomInt = max => {
  return Math.floor(Math.random() * Math.floor(max))
}
export default GetRandomInt
